import { icon } from '../../icons';
import { type ProfileDto, type PropertyDto, type ReminderDto, type TenantDto } from '../../services/api';
import { t } from '../../services/i18n';

export function getOnboardingSteps() {
  return [
    {
      id: 'profile',
      label: t('onboarding.step.profile'),
      icon: icon('user', { size: 16, className: 'wizard-step-badge-icon', attrs: 'aria-hidden="true"' }),
    },
    {
      id: 'property',
      label: t('onboarding.step.property'),
      icon: icon('home', { size: 16, className: 'wizard-step-badge-icon', attrs: 'aria-hidden="true"' }),
    },
    {
      id: 'tenant',
      label: t('onboarding.step.tenant'),
      icon: icon('user', { size: 16, className: 'wizard-step-badge-icon', attrs: 'aria-hidden="true"' }),
    },
    {
      id: 'document',
      label: t('onboarding.step.document'),
      icon: icon('file', { size: 16, className: 'wizard-step-badge-icon', attrs: 'aria-hidden="true"' }),
    },
    {
      id: 'reminder',
      label: t('onboarding.step.reminder'),
      icon: icon('bell', { size: 16, className: 'wizard-step-badge-icon', attrs: 'aria-hidden="true"' }),
    },
  ] as const;
}

export const STEPS = getOnboardingSteps();

export type OnboardingStepId = typeof STEPS[number]['id'];

export type OnboardingState = {
  currentStep: number;
  profile: ProfileDto | null;
  createdProperty: PropertyDto | null;
  createdTenant: TenantDto | null;
  createdTenantRentAmount: number | null;
  createdTenantStartDate: string | null;
  createdDocumentId: string | null;
  createdDocumentName: string | null;
  createdReminder: ReminderDto | null;
  isLoading: boolean;
  isImportingCsv: boolean;
  csvImportNotice: string | null;
  csvImportErrors: string[];
  currentUserName: string;
};

export function esc(str: string): string {
  const el = document.createElement('span');
  el.textContent = str;
  return el.innerHTML;
}

export function normalizeFormValue(value: FormDataEntryValue | null): string | null {
  const text = (typeof value === 'string' ? value : '').trim();
  return text || null;
}
